module.exports = __webpack_public_path__ + "img/p9.a3b28612.svg";